import { APP_CONFIG, AppConfigService } from "./app-config.service";

export const AppConfigServiceProvider = {
    provide: AppConfigService,
    useFactory: (config: AppConfigService): AppConfigService => config,
    deps: [APP_CONFIG]
};
